import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ServiceCookies } from '@services/ServiceCookies';
import { validateAndDecodeToken } from '@sharedHelpers/validateAndDecodeToken';
import { userProfileType } from '@entities/User/module/types/UserSchema';
import { StorageType } from '@entities/Storage/module/types/storageSchema';
import { autoType } from '@entities/Auto';
import config from '@app/config';

const baseQueryWithAuth = async (args, api, extraOptions) => {
  await validateAndDecodeToken();
  return fetchBaseQuery({
    baseUrl: config.baseApiUrl,
    prepareHeaders: headers => {
      headers.set('Accept', 'application/json');
      headers.set('content-type', 'application/json');
      headers.set('Authorization', `Bearer ${config.apiToken}`);
      headers.set(ServiceCookies.KEY, ServiceCookies.sessionId);
      headers.set(ServiceCookies.JWT_HEADER, ServiceCookies.jwtAccess);
      return headers;
    },
  })(args, api, extraOptions);
};

export const apiUser = createApi({
  reducerPath: 'apiUser',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Profile', 'Storage', 'Cars'],
  endpoints: builder => ({
    getProfile: builder.query<userProfileType, void>({
      query: () => '/api/user/profile',
      transformResponse: (response: { data: userProfileType; success: boolean }) => response.data,
      providesTags: ['Profile'],
    }),
    updateProfile: builder.mutation<{ code: number; message: string }, Partial<userProfileType>>({
      query: data => ({
        url: '/api/user/profile/update',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Profile'],
    }),
    getCars: builder.query<autoType[], void>({
      query: () => '/api/user/auto',
      transformResponse: (response: { data: autoType[]; success: boolean }) => response.data,
      providesTags: ['Cars'],
    }),
    getStorage: builder.query<StorageType[], void>({
      query: () => '/api/user/ox',
      transformResponse: (response: { data: StorageType[]; success: boolean }) => response.data,
      providesTags: ['Storage'],
    }),
  }),
});

export const { useGetProfileQuery, useUpdateProfileMutation, useGetCarsQuery, useGetStorageQuery } = apiUser;
